<template>
    <el-aside width="200px" class="border-r p-2 mui-side-menu">
        <el-menu
            :default-active="activeSection"
            @select="onSelect"
            class="el-menu-vertical"
        >
            <div>
                <a
                    :href="mainNavigationUrl"
                    class="main-navigation-link"
                >
                    <div class="mui-side-menu-back">
                        {{ $trans('profile_dossier.main_navigation') }}
                    </div>
                </a>
            </div>
            <el-menu-item
                v-for="section in sections"
                :key="section"
                :index="section"
                class="mui-side-menu-item"
            >
                {{ $trans(`profile_dossier.sections.${section}`) }}
            </el-menu-item>
        </el-menu>
    </el-aside>
</template>

<script>
export default {
    name: "SectionsMenu",
    props: {
        sections: {
            type: Array,
            required: true,
        },
        activeSection: {
            type: String,
            required: true,
        },
        mainNavigationUrl: {
            type: String,
            required: true,
        },
    },
    methods: {
        onSelect(section) {
            this.$emit("select", section);
        },
    },
};
</script>

<style scoped>
.main-navigation-link {
    text-decoration: none;
}

.el-menu {
    border: unset !important;
}

.mui-side-menu-back {
    background-color: #000000;
    color: #ffffff;
    margin: 5px 0;
    padding: 5px 10px;
    padding-left: 10px;
    padding-left: 30px;
    text-align: left;
    position: relative;
    line-height: 20px;
    font-size: 16px;
    cursor: pointer;
    width: 76%;
}

.mui-side-menu {
    width: 200px;
    margin-top: 30px;
    color: #000000;
    background-color: #ffffff !important;
    box-shadow: 3px 3px 10px 2px rgb(0 0 0 / 55%);
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
    padding: 15px 15px;
}

.mui-side-menu-item {
    white-space: normal !important;
    height: auto;
    line-height: 1.4;
    padding-top: 10px;
    padding-bottom: 10px;
    background-color: #ededed;
    color: #000000;
    margin: 5px 0 0 0;
    padding: 5px 10px;
    text-align: left;
    position: relative;
    min-height: 30px;
    font-size: 16px;
    cursor: pointer;
}

.mui-side-menu-back::after {
    content: "";
    background-image: url("/media/images/chevron_down_white.svg");
    position: absolute;
    left: 5px;
    top: 3px;
    width: 24px;
    height: 24px;
    transform: rotate(90deg);
}

.mui-side-menu-item.is-active,
.mui-side-menu-item:hover {
    background-color: #41abc4;
    color: #ffffff;
}

.cv-preview {
    width: 794px;
    margin: 0 auto;
    background: #f9f9f9;
}

.cv-page {
    position: relative;
    width: 794px;
    height: 806px;
    background: white;
    border: 1px solid #ccc;
    margin-bottom: 16px;
    overflow: hidden;
    page-break-after: always;
    word-break: break-word;
    white-space: normal;
    height: 1122px;
    padding: 40px;
    box-sizing: border-box;
    page-break-after: always;
    background: white;
    padding: 20px;
    border: 1px solid #ddd;
    min-height: 842px;
    position: relative;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    page-break-after: always;
    display: flex;
    flex-direction: column;
    min-height: 800px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    margin-bottom: 20px;
}

.cv-section {
    flex: 1 1 auto;
}

.cv-footer {
    font-size: 12px;
    color: #666;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    margin-top: 20px;
    text-align: center;
    position: relative;
}

.cv-footer-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 5px;
    text-align: left;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.cv-footer-table td {
    vertical-align: top;
    padding: 0 10px;
    border-left: 1px solid #ccc;
}

.cv-footer-table td:first-child {
    border-left: none;
}

.cv-footer-bottom-line {
    border-bottom: 1px solid #ccc;
    width: 100%;
    margin-top: 10px;
}

.cv-header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    padding: 8px 16px;
    text-align: center;
}

.cv-title {
    font-size: 20px;
    font-weight: bold;
}

.cv-logo {
    position: absolute;
    top: 70px;
    right: 16px;
    height: 40px;
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.cv-name {
    margin-top: 4px;
    font-size: 16px;
}

.cv-body {
    position: absolute;
    top: 90px;
    bottom: 16px;
    left: 16px;
    right: 16px;
    overflow: hidden;
}

.cv-section {
    margin-bottom: -11px;
}

.cv-section h3 {
    margin: 8px 0;
    font-size: 16px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 4px;
}

.cv-content {
    font-size: 14px;
}

.cv-preview {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.cv-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 10px;
}

.cv-title {
    font-size: 20px;
    font-weight: bold;
}

.cv-name {
    margin-top: 10px;
    font-size: 16px;
    font-weight: 600;
}

.cv-section {
    margin-top: 20px;
}

.section-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 5px;
}

.section-title .dossier-title {
    font: normal 400 40px/0px Barlow;
}

.section-title .name-title {
    font: normal 400 30px/24px Barlow;
}

.section-content {
    margin-top: 10px;
    white-space: pre-wrap;
}

.cv-photo {
    max-width: 150px;
    margin-top: 10px;
}

.cv-cover-page {
    padding: 40px;
    font-family: "Arial", sans-serif;
    page-break-after: always;
    margin-top: 25%;
}

.cv-cover-page .title {
    font: normal 400 30px/24px Barlow;
}

.cv-cover-page .name {
    font: normal 400 59px/48px Barlow;
    margin-top: 14px;
}

.cv-cover-page .cover-meta p {
    margin-top: 20px;
    font-size: 21px;
}

.cover-page-cv-footer {
    font-size: 12px;
    color: #666;
    border-top: 1px solid #ccc;
    padding-top: 10px;
    margin-top: 20px;
    position: absolute;
    bottom: 20px;
    width: 88%;
    left: 6%;
    box-sizing: border-box;
}

.cover-page-cv-footer p.cover-disclaimer {
    text-align: justify;
    margin-bottom: 8px;
}

.cover-footer-divider {
    border: none;
    border-top: 1px solid #ccc;
    margin: 8px 0;
}

.cover-footer-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
}

.cover-footer-table td:first-child {
    border-left: none;
}

.cover-footer-table td {
    vertical-align: top;
    padding-right: 15px;
    border-left: 1px solid #ccc;
    padding: 0 10px;
}

.cv-photo {
    width: 150px;
    height: 150px;
    margin: 20px 0;
    border-radius: 50%;
    object-fit: cover;
}

.cover-photo-wrapper {
    text-align: left;
}

.highlight {
    outline: 3px solid #409eff;
    border-radius: 8px;
    transition: outline 0.3s ease;
}
</style>
